import { render } from "./History.vue?vue&type=template&id=28fc69cd&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import "./History.vue?vue&type=style&index=0&id=28fc69cd&lang=css"
import "./History.vue?vue&type=style&index=1&id=28fc69cd&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\crescendoCat\\Work Space\\Nodejs\\thripsui\\vue-thripsui\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fc69cd"]])

export default __exports__